export default "__VITE_ASSET__RrHwVpHC__"